/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairCart } from '../../models/finnair-cart';

export interface GetCart$Params {

/**
 * CAS authentication token in Bearer format. Takes priority over the Authorization header if both are present.
 */
  oauth_token?: any;
  cartId: string;
  hash?: string;
  locale?: string;
  includeServiceCatalog?: boolean;
  frontEndQuota?: boolean;
}

export function getCart(http: HttpClient, rootUrl: string, params: GetCart$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairCart>> {
  const rb = new DapiRequestBuilder(rootUrl, getCart.PATH, 'get');

  if (params) {
    rb.header('oauth_token', params.oauth_token, {});
    rb.path('cartId', params.cartId, {});
    rb.query('hash', params.hash, {});
    rb.query('locale', params.locale, {});
    rb.query('includeServiceCatalog', params.includeServiceCatalog, {});
    rb.query('frontEndQuota', params.frontEndQuota, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairCart>;
    }),
    catchErrorAsJson()
  );
}

getCart.PATH = '/api/v2/cart/{cartId}';
